import { render, staticRenderFns } from "./locked-message.vue?vue&type=template&id=661199aa&"
import script from "./locked-message.vue?vue&type=script&lang=js&"
export * from "./locked-message.vue?vue&type=script&lang=js&"
import style0 from "./locked-message.vue?vue&type=style&index=0&id=661199aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports